var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('p',[_vm._v(_vm._s(_vm.verifyMessage))]),_c('p',{staticClass:"mt-4"},[_c('router-link',{attrs:{"to":"/login"}},[_vm._v("Til innlogging")])],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }